<template>
  <v-container
    class="fill-height"
    fluid
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="4"
      >
        <v-card class="elevation-12">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>Galaxie Media</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <div id="clerk-signin-container"></div>
            <div v-if="loading" class="text-center">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
              <p class="mt-2">Chargement...</p>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      loading: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initClerkSignIn()
    })
  },
  methods: {
    async initClerkSignIn() {
      const clerk = this.$clerk

      // Wait for Clerk to be ready
      if (!clerk.loaded) {
        await clerk.load()
      }

      this.loading = false

      // If already signed in, redirect to home
      if (clerk.user) {
        this.$router.push('/')
        return
      }

      // Mount Clerk sign-in component
      clerk.mountSignIn(document.getElementById('clerk-signin-container'), {
        afterSignInUrl: '/',
        afterSignUpUrl: '/',
        appearance: {
          elements: {
            rootBox: {
              width: '100%'
            },
            card: {
              boxShadow: 'none',
              border: 'none'
            }
          }
        }
      })
    }
  },
  beforeDestroy() {
    // Unmount Clerk sign-in when leaving
    if (this.$clerk) {
      this.$clerk.unmountSignIn(document.getElementById('clerk-signin-container'))
    }
  }
}
</script>

<style scoped>
#clerk-signin-container {
  min-height: 300px;
}
</style>
